import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'AI-Powered Screening',
    title: 'Screen candidates at scale with AI precision',
    subtitle: 'Automate resume screening, application fraud detection, and candidate shortlisting. Reduce time-to-hire by 80% while improving quality of hire.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #0076A3 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Screening Capabilities',
      title: 'Everything you need to screen smarter',
      features: [
        { icon: '\ud83d\udcca', title: 'AI Resume Scoring', desc: 'Upload resumes in bulk. AI parses skills, experience, and education \u2014 then scores and ranks every candidate against your job description automatically.' },
        { icon: '\ud83c\udfaf', title: 'JD-Based Matching', desc: 'Upload or paste a job description. AI extracts requirements and matches candidates on skills fit, experience level, education, and domain relevance.' },
        { icon: '\ud83d\udcc4', title: 'Bulk Resume Upload', desc: 'Drag and drop up to 50 resumes at once. Each file is parsed, scored, and ranked individually with real-time progress tracking per file.' },
        { icon: '\u26a1', title: 'Instant Shortlisting', desc: 'Candidates are automatically banded \u2014 Exceptional, Strong, Good, Maybe or Reject \u2014 with detailed score breakdowns for each.' },
        { icon: '\ud83d\udd0d', title: 'Skill Gap Analysis', desc: 'See exactly which required skills each candidate has and which they lack. Identify training needs before you even start interviewing.' },
        { icon: '\ud83d\udce5', title: 'JD Auto-Fill', desc: 'Upload a JD file (PDF, DOCX, TXT) and AI extracts the title, skills, experience, location, and job type \u2014 auto-populating your job listing.' },
      ],
      columns: 3,
    },
    {
      label: 'How It Works',
      title: 'From JD to ranked shortlist in minutes',
      desc: 'Skip the manual resume review. Upload your job description and resumes, and let AI do the heavy lifting. Every candidate gets a detailed score card.',
      bullets: [
        'Upload or create a job description',
        'Drop resumes \u2014 PDF, DOCX, or TXT',
        'AI parses and extracts structured data from each resume',
        'Each candidate scored 0-100 against the JD',
        'Ranked list with fit recommendation, matched/missing skills',
        'Export shortlist as CSV for sharing',
      ],
      visual: '\ud83d\udcca',
      visualLabel: 'AI Screening Pipeline',
    },
    {
      label: 'Candidate Pipeline',
      title: 'See your entire pipeline at a glance',
      desc: 'The recruiter dashboard shows every candidate across every job \u2014 self-applied and uploaded. Filter by source, score, and fit. Push assessments and interviews with one click.',
      bullets: [
        'Unified Applications view across all jobs',
        'Filter: All, Self-Applied, Recruiter-Uploaded',
        'Score and fit displayed per candidate',
        'One-click: Send Assessment, Send Interview, View Profile',
        'Self-applied candidates tagged with green badge',
        'Real-time processing status with animated progress',
      ],
      visual: '\ud83d\ude80',
      visualLabel: 'Recruiter Pipeline Dashboard',
    },
    {
      label: 'Anti-Fraud',
      title: 'Detect application fraud before it costs you',
      desc: 'AI analyzes resumes for inconsistencies, inflated claims, and suspicious patterns. Combined with assessment anti-cheating, you get a complete integrity picture.',
      bullets: [
        'Resume inconsistency detection',
        'AI-generated resume flagging',
        'Duplicate application detection across jobs',
        'Cross-reference with assessment integrity scores',
        'Comprehensive candidate integrity report',
      ],
      visual: '\ud83d\udee1\ufe0f',
      visualLabel: 'Fraud Detection Engine',
    },
  ],
  testimonial: {
    quote: 'We used to spend 3 days screening 200 resumes per role. With CHIRE Screening, we get a ranked shortlist in under an hour. The accuracy is remarkable.',
    name: 'Jennifer L.',
    role: 'Head of Talent Acquisition, GlobalTech',
  },
  cta: {
    title: 'Start screening smarter today',
    desc: 'Upload your first batch of resumes and see AI-powered rankings in minutes. Start with the Starter plan.',
  },
};

export default function ScreeningPage() { return <ProductPageTemplate data={DATA} />; }
